/**
 * 工作流启动时机
 */
export enum WFStartMode {
    /**
     * 立即启动
     */
    IMMEDIATELY = "IMMEDIATELY",
    /**
     * 等待信号启动
     */
    WAITINGSIGNAL = "WAITINGSIGNAL",
    /**
     * 外部启动
     */
    EXTERN = "EXTERN"
}